import { gql } from '@apollo/client'

export default gql(`
  query($type: String! $project: String){
    filterDataList(
      type:$type
      project:$project
      ) {
        sortableFields{
            name
            displayName
        }
    }
  }
  `
)
